// sections-3.jsx — extraído de index.html el 2026-08-28 (Etapa 1, Bloque C).
//
// Hasta hoy este código vivía incrustado en index.html dentro de un
// <script type="text/babel"> que @babel/standalone compilaba en el navegador de
// cada visitante. El atributo data-source lo atribuía a «NUEVA WEB/sections-3.jsx»,
// una carpeta que no existe en el repositorio ni en el disco: el bloque incrustado
// era la única fuente de verdad (hallazgo H5 del inventario).
//
// El contenido es copia EXACTA del bloque original. No se reformateó ni se
// renombró nada: se compila con las mismas opciones que aplicaba el CDN y la
// salida debe ser byte a byte la misma. Ver scripts/build-jsx.mjs.
//
// Se carga como script clásico, NO como módulo: las declaraciones de nivel
// superior son globales y las otras entradas del home las leen por nombre.

/* global React */
(() => {

// ============================================================
// WAZE / GOOGLE MAPS integration
// ============================================================
function NavSection({ copy }) {
  return (
    <section className="section section--blue-grad" id="navigate" data-screen-label="07 Waze & Google">
      <div className="section-inner">
        <div className="nav-grid">
          <div className="nav-stage reveal">
            <svg className="nav-stage__route" viewBox="0 0 100 100" preserveAspectRatio="none">
              <path d="M 8 90 Q 30 70 38 50 T 60 28 Q 75 22 92 18" />
            </svg>
            <img className="nav-stage__pin" src="/imagenes/icons/restaurante_icon.png" alt="" />
            <div className="nav-stage__waze">
              <img src="/imagenes/icons/waze-icon.png" alt="" />
              <div>
                <strong>{copy.navigate.waze}</strong>
                <span>{copy.navigate.distance}</span>
              </div>
            </div>
            <div className="nav-stage__google">
              <img src="/imagenes/icons/Google-icon.png" alt="" />
              <div>
                <strong>{copy.navigate.google}</strong>
                <span>{copy.navigate.googleSub}</span>
              </div>
            </div>
          </div>
          <div className="reveal">
            <span className="kicker kicker--white">{copy.navigate.kicker}</span>
            <h2 className="title">{copy.navigate.titlePrefix} <em>{copy.navigate.titleEm}</em> {copy.navigate.titleSuffix}</h2>
            <p className="lede">{copy.navigate.lede}</p>
            <div className="nav-features">
              <div className="nav-feature">
                <div className="nav-feature__icon">
                  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C8 2 5 5 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-4-3-7-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z" /></svg>
                </div>
                <div>
                  <h4>{copy.navigate.features[0].title}</h4>
                  <p>{copy.navigate.features[0].desc}</p>
                </div>
              </div>
              <div className="nav-feature">
                <div className="nav-feature__icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="3 11 22 2 13 21 11 13 3 11" /></svg>
                </div>
                <div>
                  <h4>{copy.navigate.features[1].title}</h4>
                  <p>{copy.navigate.features[1].desc}</p>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </section>);

}

// ============================================================
// ANALYTICS — live counters + bar chart
// ============================================================
function AnalyticsSection() {
  const [tab, setTab] = React.useState("week");
  const [stats, setStats] = React.useState({ views: 0, calls: 0, waze: 0, whats: 0 });
  const ref = React.useRef(null);
  const targets = { week: { views: 12480, calls: 318, waze: 612, whats: 488 },
    month: { views: 48206, calls: 1142, waze: 2380, whats: 1820 },
    year: { views: 522040, calls: 13280, waze: 27914, whats: 21206 } };

  React.useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) animate();
    }, { threshold: 0.3 });
    io.observe(el);
    return () => io.disconnect();
  }, []);

  React.useEffect(() => animate(), [tab]);

  function animate() {
    const t = targets[tab];
    const dur = 1200;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min(1, (now - start) / dur);
      const e = 1 - Math.pow(1 - p, 3);
      setStats({
        views: Math.round(t.views * e),
        calls: Math.round(t.calls * e),
        waze: Math.round(t.waze * e),
        whats: Math.round(t.whats * e)
      });
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  const seed = tab === "week" ? [62, 48, 55, 70, 82, 98, 76] : tab === "month" ? [70, 62, 58, 80, 90, 72, 88] : [55, 68, 72, 80, 85, 90, 78];

  return (
    <section className="section section--paper" id="analytics" data-screen-label="08 Analytics">
      <div className="section-inner">
        <div className="reveal" style={{ textAlign: "center" }}>
          <span className="kicker" style={{ marginLeft: "auto", marginRight: "auto" }}>Chapter 07 · Analytics</span>
          <h2 className="title title--center">See exactly <em>how travelers find you.</em></h2>
          <p className="lede lede--center">
            A real-time dashboard shows views, calls, WhatsApp opens and Waze taps for every Hotspot —
            so businesses know which channels convert and which photos work.
          </p>
        </div>

        <div className="analytics-board reveal" ref={ref}>
          <div className="ab__head">
            <div className="ab__title">
              <small>Hotspot · Manuel Antonio Beach Restaurant</small>
              Engagement overview
            </div>
            <div className="ab__tabs">
              <button className={tab === "week" ? "is-on" : ""} onClick={() => setTab("week")}>This week</button>
              <button className={tab === "month" ? "is-on" : ""} onClick={() => setTab("month")}>This month</button>
              <button className={tab === "year" ? "is-on" : ""} onClick={() => setTab("year")}>This year</button>
            </div>
          </div>
          <div className="ab__stats">
            <div className="ab__stat">
              <div className="ab__stat__label"><img src="/imagenes/icons/info_icon.png" alt="" />Map Views</div>
              <span className="ab__stat__value">{stats.views.toLocaleString()}</span>
              <span className="ab__stat__delta">↑ 18% vs prev</span>
            </div>
            <div className="ab__stat">
              <div className="ab__stat__label"><img src="/imagenes/icons/phone-icon.png" alt="" />Phone calls</div>
              <span className="ab__stat__value">{stats.calls.toLocaleString()}</span>
              <span className="ab__stat__delta">↑ 12%</span>
            </div>
            <div className="ab__stat">
              <div className="ab__stat__label"><img src="/imagenes/icons/waze-icon.png" alt="" />Waze opens</div>
              <span className="ab__stat__value">{stats.waze.toLocaleString()}</span>
              <span className="ab__stat__delta">↑ 24%</span>
            </div>
            <div className="ab__stat">
              <div className="ab__stat__label"><img src="/imagenes/icons/whatsapp-icon.png" alt="" />WhatsApp</div>
              <span className="ab__stat__value">{stats.whats.toLocaleString()}</span>
              <span className="ab__stat__delta">↑ 31%</span>
            </div>
          </div>
          <div className="ab__chart">
            <div className="ab__chart-head">
              <strong>Engagement breakdown</strong>
              <div className="ab__chart-legend">
                <span><i style={{ background: "var(--cr-blue)" }} />Views</span>
                <span><i style={{ background: "var(--cr-blue-bright)" }} />Waze</span>
                <span><i style={{ background: "var(--cr-yellow)" }} />WhatsApp</span>
              </div>
            </div>
            <div className="ab__bars">
              {days.map((d, i) =>
              <div className="ab__bar-col" key={d}>
                  <div className="ab__bar-stack" style={{ height: `${seed[i]}%` }}>
                    <i className="s1" style={{ height: "55%" }} />
                    <i className="s2" style={{ height: "25%" }} />
                    <i className="s3" style={{ height: "20%" }} />
                  </div>
                  <span className="ab__bar-label">{d}</span>
                </div>
              )}
            </div>
          </div>
          <div className="ab__realtime">
            <span className="ab__realtime__dot" />
            <strong>Real-time</strong> · 47 travelers viewing your Pin right now
          </div>
        </div>
      </div>
    </section>);

}

// ============================================================
// SOCIAL / COMMUNITY
// ============================================================
function SocialSection({ copy }) {
  const postMeta = [
  { net: "instagram", name: "@crmaps", likes: "1.2k", comments: 84, img: "/imagenes/index/Instagram_post_2.webp" },
  { net: "instagram", name: "@crmaps", likes: "984", comments: 51, img: "/imagenes/index/Instagram_post_1.webp" },
  { net: "facebook", name: "CRMaps", likes: "642", comments: 38, img: "/imagenes/index/facebook_post_2.webp" },
  { net: "facebook", name: "CRMaps", likes: "2.4k", comments: 162, img: "/imagenes/index/facebook_post_1.webp" }];
  const posts = postMeta.map((post, index) => ({ ...post, caption: copy.community.posts[index] }));

  return (
    <section className="section section--paper" id="community" data-screen-label="09 Community">
      <div className="section-inner">
        <div className="reveal" style={{ textAlign: "center" }}>
          <span className="kicker" style={{ marginLeft: "auto", marginRight: "auto" }}>{copy.community.kicker}</span>
          <h2 className="title title--center">{copy.community.titlePrefix} <em>{copy.community.titleEm}</em></h2>
          <p className="lede lede--center">{copy.community.lede}</p>
        </div>

        <div className="social-grid reveal-stagger">
          {posts.map((p, i) =>
          <div className="social-card" key={i}>
              <div className="social-card__head">
                <img src={`/imagenes/icons/${p.net}-icon.png`} alt="" />
                <strong>{p.name}</strong>
              </div>
              <img className="social-card__post" src={p.img} alt="" />
            </div>
          )}
        </div>

        <div style={{ display: "flex", justifyContent: "center", gap: 12, marginTop: 36, flexWrap: "wrap" }}>
          <a href="https://www.instagram.com/crmaps506/" className="btn btn--ghost social-link" target="_blank" rel="noopener noreferrer"><img src="/imagenes/icons/instagram-icon.png" style={{ width: 18, height: 18 }} alt="" />{copy.community.instagram}</a>
          <a href="https://www.facebook.com/crmaps" className="btn btn--ghost social-link" target="_blank" rel="noopener noreferrer"><img src="/imagenes/icons/facebook-icon.png" style={{ width: 18, height: 18 }} alt="" />{copy.community.facebook}</a>
        </div>
      </div>
    </section>);

}

// ============================================================
// CONTACT FORM
// ============================================================
function ContactSection({ copy }) {
  const [sent, setSent] = React.useState(false);
  const [error, setError] = React.useState("");
  const [sending, setSending] = React.useState(false);
  const handleSubmit = async (event) => {
    event.preventDefault();
    setSent(false);
    setError("");
    setSending(true);
    const form = event.currentTarget;
    const payload = Object.fromEntries(new FormData(form).entries());
    payload.source = "index.html";
    try {
      const response = await fetch("/send-email.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok || !result.ok) {
        throw new Error(result.error || "Contact request failed");
      }
      form.reset();
      setSent(true);
    } catch (err) {
      setError(copy.contact.error);
    } finally {
      setSending(false);
    }
  };
  return (
    <section className="section section--cream" id="contact" data-screen-label="11 Contact">
      <div className="section-inner">
        <div className="contact-grid">
          <div className="contact-info reveal">
            <span className="kicker">{copy.contact.kicker}</span>
            <h3>{copy.contact.titlePrefix} <em style={{ color: "var(--cr-orange)", fontStyle: "normal" }}>{copy.contact.titleEm}</em></h3>
            <p>{copy.contact.lede}</p>
            <div className="contact-channels">
              <a className="contact-channel" href="#"><img src="/imagenes/icons/whatsapp-icon.png" alt="" /><div><strong>{copy.contact.whatsapp}</strong><span>{copy.contact.whatsappSub}</span></div></a>
              <a className="contact-channel" href="#"><img src="/imagenes/icons/phone-icon.png" alt="" /><div><strong>{copy.contact.call}</strong><span>{copy.contact.callSub}</span></div></a>
              <a className="contact-channel" href={`mailto:${copy.contact.email}`}><img src="/imagenes/icons/web-icon.png" alt="" /><div><strong>{copy.contact.email}</strong><span>{copy.contact.emailSub}</span></div></a>
            </div>
          </div>
          <form className="contact-form reveal" onSubmit={handleSubmit}>
            {sent &&
            <div style={{ padding: 14, background: "rgba(0,136,62,0.1)", border: "1px solid rgba(0,136,62,0.3)", borderRadius: 10, color: "var(--cr-green-deep)", font: "600 14px Roboto", marginBottom: 18 }}>
                {copy.contact.success}
              </div>
            }
            {error &&
            <div style={{ padding: 14, background: "rgba(220,38,38,0.1)", border: "1px solid rgba(220,38,38,0.25)", borderRadius: 10, color: "#b91c1c", font: "600 14px Roboto", marginBottom: 18 }}>
                {error}
              </div>
            }
            <div className="form-row">
              <div className="form-field">
                <label>{copy.contact.labels.name}</label>
                <input required type="text" name="name" placeholder="María Hernández" />
              </div>
              <div className="form-field">
                <label>{copy.contact.labels.business}</label>
                <input required type="text" name="business" placeholder="El Avión Restaurante" />
              </div>
            </div>
            <div className="form-row">
              <div className="form-field">
                <label>{copy.contact.labels.email}</label>
                <input required type="email" name="email" placeholder="hola@example.com" />
              </div>
              <div className="form-field">
                <label>{copy.contact.labels.whatsapp}</label>
                <input type="tel" name="whatsapp" placeholder="+506 ..." />
              </div>
            </div>
            <div className="form-row">
              <div className="form-field">
                <label>{copy.contact.labels.type}</label>
                <select name="type">
                  {copy.contact.businessTypes.map((option) => <option key={option}>{option}</option>)}
                </select>
              </div>
              <div className="form-field">
                <label>{copy.contact.labels.region}</label>
                <select name="region">
                  {copy.contact.regions.map((option) => <option key={option}>{option}</option>)}
                </select>
              </div>
            </div>
            <div className="form-row form-row--full">
              <div className="form-field">
                <label>{copy.contact.labels.message}</label>
                <textarea name="message" placeholder={copy.contact.messagePlaceholder} />
              </div>
            </div>
            <div className="form-actions">
              <small>{copy.contact.disclaimer}</small>
              <button type="submit" className="btn btn--primary" disabled={sending}>{sending ? copy.contact.sending : copy.contact.submit}</button>
            </div>
          </form>
        </div>
      </div>
    </section>);

}

// ============================================================
// FOOTER
// ============================================================
function Footer({ copy, lang }) {
  const [openModal, setOpenModal] = React.useState(null);
  const modalContent = openModal === "about"
    ? {
      title: copy.footer.aboutModalTitle,
      updated: null,
      paragraphs: copy.footer.aboutModalText,
    }
    : openModal === "privacy"
      ? {
        title: copy.footer.privacyModalTitle,
        updated: copy.footer.privacyUpdated,
        paragraphs: copy.footer.privacyModalText,
      }
      : null;

  React.useEffect(() => {
    if (!openModal) return undefined;
    const onKeyDown = (event) => {
      if (event.key === "Escape") setOpenModal(null);
    };
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [openModal]);

  return (
    <footer className="site-footer" id="footer" style={{ backgroundColor: "rgb(0, 67, 130)" }}>
      <div className="sf-grid">
        <div className="sf-brand">
          <img src="/imagenes/index/logo_2026_white.webp" alt="CRMaps" />
          <p>{copy.footer.brand}</p>
          <div className="sf-social">
            <a href="https://www.facebook.com/crmaps" aria-label="Facebook">
              <svg viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
            </a>
            <a href="https://www.instagram.com/crmaps506" aria-label="Instagram">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1.5" fill="currentColor" stroke="none"/></svg>
            </a>
            <a href="https://wa.me/50647073168" aria-label="WhatsApp">
              <svg viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/></svg>
            </a>
          </div>
        </div>
        <div className="sf-col">
          <h5>{copy.footer.business}</h5>
          <ul>
            <li><a href="/for-business.html">{copy.footer.listPin}</a></li>
            <li><a href="/for-business.html">{copy.footer.sponsorRegion}</a></li>
            {false && <li><a href="#analytics">Analytics</a></li>}
            <li><a href="/for-business.html#contact">{copy.footer.talkSales}</a></li>
          </ul>
        </div>
        <div className="sf-col">
          <h5>{copy.footer.company}</h5>
          <ul>
            <li><button className="footer-link-button" type="button" onClick={() => setOpenModal("about")}>{copy.footer.about}</button></li>
            <li><a href="#community">{copy.footer.community}</a></li>
            <li><a href="#contact">{copy.footer.contact}</a></li>
            <li><button className="footer-link-button" type="button" onClick={() => setOpenModal("privacy")}>{copy.footer.privacy}</button></li>
          </ul>
        </div>
        <a className="sf-slothy-link" href="/for-business.html" aria-label={copy.footer.listPin}>
          <img className="sf-slothy" src={`/imagenes/index/slothy_venta_${lang === "es" ? "es" : "en"}.webp`} alt="" />
        </a>
      </div>
      <div className="sf-bottom">
        <span>{copy.footer.bottom}</span>
      </div>
      {modalContent && (
        <div className="footer-modal" role="dialog" aria-modal="true" aria-labelledby="footer-about-title">
          <button className="footer-modal__backdrop" type="button" aria-label={copy.footer.close} onClick={() => setOpenModal(null)} />
          <div className="footer-modal__panel">
            <button className="footer-modal__close" type="button" aria-label={copy.footer.close} onClick={() => setOpenModal(null)}>×</button>
            <h3 id="footer-about-title">{modalContent.title}</h3>
            {modalContent.updated && <p className="footer-modal__updated">{modalContent.updated}</p>}
            {modalContent.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
          </div>
        </div>
      )}
    </footer>);

}

window.NavSection = NavSection;
window.AnalyticsSection = AnalyticsSection;
window.SocialSection = SocialSection;
window.ContactSection = ContactSection;
window.Footer = Footer;
})();
  